/**
 * 应用状态管理
 */
const state = {
  sidebar: {
    collapsed: false,
  },
  device: 'desktop', // desktop | mobile
}

const mutations = {
  TOGGLE_SIDEBAR(state) {
    state.sidebar.collapsed = !state.sidebar.collapsed
  },
  SET_SIDEBAR_COLLAPSE(state, collapsed) {
    state.sidebar.collapsed = collapsed
  },
  SET_DEVICE(state, device) {
    state.device = device
  },
}

const actions = {
  toggleSidebar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
}

const getters = {
  sidebarCollapsed: (state) => state.sidebar.collapsed,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
